module.exports = __webpack_public_path__ + "static/img/aboutUs3.d3e1c227.png";